import axios from "axios";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });
export const errMsg = (e) => {
  const d = e.response?.data?.detail;
  if (e.response?.status === 401 || e.response?.status === 403) return "Session expired — please sign in again.";
  return typeof d === "string" ? d : Array.isArray(d) ? `${d[0]?.loc?.slice(-1)[0]}: ${d[0]?.msg}` : "Request failed";
};
export const fail = (e) => toast.error(errMsg(e));
